<template>
  <div class="step step--intro flex flex-col">
    <div>
      <img
        src="@/assets/seedlegals-logo.svg"
        alt="SeedLegals Logo"
        class="sl-logo"
      />
    </div>

    <div class="flex-auto flex flex-wrap items-center -ml-8">
      <div class="md:w-1/2 w-full pl-8 relative z-10 mt-4 md:mt-0">
        <h1 class="main-heading font-semibold leading-none">
          {{ $root.intro.heading }}
        </h1>
        <p class="text-22px">
          {{ $root.intro.content }}
        </p>
        <button @click="$root.stepping = true" class="c-btn c-btn--accent">
          {{ $root.intro.button }}
        </button>
      </div>

      <div class="md:w-1/2 w-full pl-8 -mt-12 sm:-mt-16 md:mt-0">
        <div class="o-ratio">
          <div class="o-ratio__content">
            <img
              :src="$root.intro.image"
              alt="SeedFAST"
              class="relative intro-graphic"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.text-22px {
  @apply mt-5 mb-8;
  font-size: 20px;
  @screen md {
    font-size: 22px;
  }
}
.sl-logo {
  max-width: 170px;
  @screen md {
    max-width: 260px;
  }
}
.main-heading {
  font-size: 52px;
  @screen md {
    font-size: 64px;
  }
}

.o-ratio {
  position: relative;
  width: 100%;
  &:before {
    display: block;
    content: '';
    width: 100%;
    padding-top: (145 / 122) * 100%;
  }
  > .o-ratio__content {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    img {
      height: 100%;
      width: 100%;
      object-fit: contain;
    }
  }
}
</style>
